<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  created() {
    // 页面加载时，将 localStorage 的 token 同步到 sessionStorage（作为本窗口镜像）
    const initialToken = localStorage.getItem('token')
    if (initialToken) {
      sessionStorage.setItem('token', initialToken)
    }

    // 方案1：storage 事件 — 其他窗口登录/登出时，当前窗口实时响应
    // 只在其他标签页修改 localStorage 时触发，不会误触发
    window.addEventListener('storage', (e) => {
      if (e.key === 'token' && e.newValue !== e.oldValue) {
        // 如果已经在登录页，不需要重复跳转
        if (this.$route.path !== '/login') {
          sessionStorage.clear()
          this.$router.push('/login')
        }
      }
    })

    // 方案2：visibilitychange 事件 — 用户切回当前窗口时兜底检查 token 是否被其他窗口变更
    // 通过比较 localStorage（跨窗口共享）和 sessionStorage（本窗口镜像）判断：
    //   - 两者一致：本窗口内操作（登录/登出），无需处理
    //   - 两者不同：其他窗口修改了 token，需要跳转登录页
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        const localStorageToken = localStorage.getItem('token')
        const sessionStorageToken = sessionStorage.getItem('token')
        if (localStorageToken !== sessionStorageToken) {
          if (this.$route.path !== '/login') {
            sessionStorage.clear()
            this.$router.push('/login')
          }
        }
      }
    })
  }
}
</script>

<style lang="scss">
@import './style/sidebar.css';
@import './style/buttons.css';

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
}

#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue